// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

declare function require(moduleName: string): any;

const version = require('../../package.json').version;

// export const environment = {
//   production: false,
//   authUrl: 'http://test.idp.egov.kz',
//   api_url: 'http://api.test.sc.egov.kz/',
//   old_api: 'http://api.test.sc.egov.kz/',
//   api_version: 'v1',
//   VERSION: version,
//   domain: '.egov.kz',
//   workflowUrl: 'http://api.test.sc.egov.kz',
//   frontUrl: 'http://test.sc.egov.kz',
//   egovUrl: 'http://test.my.egov.kz/',
//   contractIDS: {
//     PLEDGE_ID: '654e69a3-750f-438e-87f4-27edc3dc8785', // залог
//     CESSION_ID: '0acb8a03-3eba-4122-a6b5-30ca9112e4d4',
//     HOME_ID: 'dcb172ed-6d47-4ba0-b609-47c88d52efcf', // баспана
//     AUTO_ID: 'a013436b-0d95-468f-b065-84f18e7b7c19',
//     USTAV_SINGLE_ID: '48b9cb9e-3907-4b15-88dd-b6f8fd09e551', // Устав — один учредитель
//     USTAV_MULTI_ID: '3f31d295-b6fe-42c2-ab3c-1e4534a6f65e',
//   },
//   env: 'TEST',
//   debugPanel: true
// };
export const environment = {
  production: true,
  authUrl: 'https://idp.egov.kz',
  api_url: 'https://api-sc.egov.kz/',
  old_api: 'https://api-sc.egov.kz/',
  api_version: 'v1',
  VERSION: version,
  domain: '.egov.kz',
  workflowUrl: 'https://api-sc.egov.kz',
  frontUrl: 'https://sc.egov.kz',
  egovUrl: 'https://my.egov.kz/',
  contractIDS: {
    PLEDGE_ID: 'd70497ff-2b8a-4434-afef-68651b97aea0',
    CESSION_ID: '9db0e7bf-490b-49c5-83af-7df0cd71bc9a',
    HOME_ID: 'c6515f1c-1690-4cf0-9b02-b028696ce7d1',
    AUTO_ID: '86671f52-c7f1-4334-b044-a645c2a84d40',
    USTAV_SINGLE_ID: '', // TODO(бэк): боевой documentId Устава с одним учредителем
    USTAV_MULTI_ID: '', // TODO(бэк): боевой documentId Устава с несколькими учредителями
  },
  env: 'PROD',
  debugPanel: false
};

// Локально (ng serve) против TEST: REST идёт через прокси /api-test
// (см. proxy.conf.json) — тот же origin, что у фронта, без CORS, а cookie
// сессии перезаписываются на localhost.
// export const environment = {
//   production: false,
//   authUrl: 'http://test.idp.egov.kz',
//   api_url: '/api-test/',
//   old_api: '/api-test/',
//   api_version: 'v1',
//   VERSION: version,
//   domain: '.egov.kz',
//   workflowUrl: '/api-test',
//   frontUrl: 'http://test.sc.egov.kz',
//   egovUrl: 'http://test.my.egov.kz/',
//   contractIDS: {
//     PLEDGE_ID: '654e69a3-750f-438e-87f4-27edc3dc8785', // залог
//     CESSION_ID: '0acb8a03-3eba-4122-a6b5-30ca9112e4d4',
//     HOME_ID: 'dcb172ed-6d47-4ba0-b609-47c88d52efcf', // баспана
//     AUTO_ID: 'a013436b-0d95-468f-b065-84f18e7b7c19',
//     USTAV_SINGLE_ID: '48b9cb9e-3907-4b15-88dd-b6f8fd09e551', // Устав — один учредитель
//     USTAV_MULTI_ID: '3f31d295-b6fe-42c2-ab3c-1e4534a6f65e',
//   },
//   env: 'LOCAL_TEST',
//   debugPanel: true
// };

// Локально (ng serve) против PROD: REST идёт через прокси /api-prod
// (см. proxy.conf.json).
// export const environment = {
//   production: false,
//   authUrl: 'https://idp.egov.kz',
//   api_url: '/api-prod/',
//   old_api: '/api-prod/',
//   api_version: 'v1',
//   VERSION: version,
//   domain: '.egov.kz',
//   workflowUrl: '/api-prod',
//   frontUrl: 'https://sc.egov.kz',
//   egovUrl: 'https://my.egov.kz/',
//   contractIDS: {
//     PLEDGE_ID: 'd70497ff-2b8a-4434-afef-68651b97aea0',
//     CESSION_ID: '9db0e7bf-490b-49c5-83af-7df0cd71bc9a',
//     HOME_ID: 'c6515f1c-1690-4cf0-9b02-b028696ce7d1',
//     AUTO_ID: '86671f52-c7f1-4334-b044-a645c2a84d40',
//     USTAV_SINGLE_ID: '', // TODO(бэк): боевой documentId Устава с одним учредителем
//     USTAV_MULTI_ID: '', // TODO(бэк): боевой documentId Устава с несколькими учредителями
//   },
//   env: 'LOCAL_PROD',
//   debugPanel: true
// };
